import { FC, Suspense } from 'react';
import { ErrorBoundary } from 'components/molecules/error-boundary';
import { lazyWithRetry } from 'utils/lazyWithRetry';
import { identifyCurrentOs, OsList } from './utils';

const LazyCustomScrollCSS = lazyWithRetry(() =>
  import('./custom-scroll').then(({ CustomScrollCSS }) => ({
    default: CustomScrollCSS,
  })),
);

interface Props {
  blacklist: OsList[];
}

export const CustomScroll: FC<React.PropsWithChildren<Props>> = ({
  blacklist,
}) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={null}>
        {blacklist.includes(identifyCurrentOs()) ? null : (
          <LazyCustomScrollCSS />
        )}
      </Suspense>
    </ErrorBoundary>
  );
};
